/* global IntersectionObserver */
import { useRef, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const TextPopup = (props) => {
  const { className, children, delay, yOffset } = props

  const [show, setShow] = useState(false)
  const popupEl = useRef(null)

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: [1]
  }

  const observeCallback = (entry, observer) => {
    const threshold = observer.thresholds[0]

    if (entry[0].intersectionRatio >= threshold) {
      if (delay) {
        setTimeout(() => {
          setShow(true)
        }, delay)
      } else {
        setShow(true)
      }
    } else {
      // if we want to, reset here
    }
  }

  const observe = (element) => {
    const observer = new IntersectionObserver(observeCallback, options)

    observer.observe(element.current)
  }

  useEffect(() => {
    observe(popupEl)
  })

  return (
    <Mask className={className} ref={popupEl}>
      <TextWrap isActive={show} yOffset={yOffset}>{children}</TextWrap>
    </Mask>
  )
}

const Mask = styled.span`
  display: block;
  overflow: visible hidden;
`

const TextWrap = styled.span`
  display: block;
  margin-bottom: 0.05em;
  transform: ${ ({ yOffset }) => `translate3d(0, ${ yOffset }, 0) ` };
  transition: transform 1.2s cubic-bezier(0.4, 0, 0, 1);

  ${ ({ isActive }) => isActive && css`
    transform: none;
  ` }
`

TextPopup.defaultProps = {
  className: '',
  children: null,
  delay: null,
  yOffset: '100%'
}

TextPopup.propTypes = {
  className: PropTypes.string,
  /** The time, in milliseconds, to wait for the animation to run after element is within viewport */
  delay: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  yOffset: PropTypes.string,
}

export default TextPopup
